import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbFormattedDateString, bbGetRequestedAttackStatusNameFromID,
    filterObject,
    mapObject
} from "../../../util/bbHelpers";
import {
    fetchCustomers, fetchPerimeterAttacksMetaAction, fetchRequestedAttacks, fetchTargetAction,
    fetchTargets,

} from "../../../actions";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Tooltip from "@material-ui/core/Tooltip";
import BBDataTable from "../tables/BBDataTable";
import {Chip} from "@material-ui/core";
import { fetchVectorsAction} from "../../../actions";
import {renderCellExpand} from "./DataGridRenderCellExpand";

const TableContainer = (props) => {

    const {customerId, onRowSelected = null} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView, loadingVectors, loadingTargets, loadingMetaAttacks, metaAttacks} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
  //from the customer, pull the ACTIVE target data if it exists
    const vectors = customer ? customer.vectors ? customer.vectors : null : null;
    const targets = customer ? customer.targets ? customer.targets : null : null;
    const totalNumAttacks = metaAttacks ? metaAttacks[customerId] ?  metaAttacks[customerId].total.perimeter : null : null;
    const activeTargets = customer ? customer.targets ? filterObject(customer.targets, (_, target) => target.IsActive !== false) : null : null;

    const {requestedAttacks, loadingRequestedAttacks} = useSelector(({insider}) => insider);
    const requestedAttacksForCustomer = customer ? requestedAttacks ? requestedAttacks[customer.CustomerId] ? requestedAttacks[customer.CustomerId] : {} : {} : {};

    const vectorsWithTargetsPresent = (vectors, targets) => {
        if(vectors && Object.keys(vectors).length && targets && Object.keys(targets).length) {
            // console.log("looking for matching vectors and targets vectors: ", vectors, "targets: ", targets);
            const list = []
            for (const vectorId in vectors) {
                //look for the corresponding target
                // console.log("Inside the vectors loop...");
                const foundTarget = targets[vectors[vectorId].TargetId] ? targets[vectors[vectorId].TargetId] : false;
                if (foundTarget) {
                    // console.log("Found a match. Vector: ", vectors[vectorId], "found target: ", foundTarget);
                    list.push({
                        "vector": vectors[vectorId],
                        "target": foundTarget
                    })
                } else {
                    //target wasn't found in local store, so initiate a dispatch
                    // console.log("Dispatching for target: ", vectors[vectorId].TargetId)

                    //don't fetch this because now we are prefetchign all targets.
                    dispatch(fetchTargetAction({
                        customerId: customerId,
                        targetId: vectors[vectorId].TargetId
                    }))
                    // add a null target, so can show that it's loading
                    list.push({
                        "vector": vectors[vectorId],
                        "target": null
                    })
                }
            }
            // console.log("List made: ", list);
            return list;
        } else {
            // console.log("vectors and targets was false")
            return [];
        }
    }

    // const allVectorTargetPairs = vectorsWithTargetsPresent(vectors, targets);

    // const extractAttacksWithVTPairs = (vtPairs) => {
    //     //for each VT pair, create an object containing all attacks, and include the vt object in the attack record
    //     const attackData = {}
    //     for (const vt of vtPairs) {
    //         //get all of the attacks from the given vector
    //         const v = vt.vector;
    //
    //         for (const attackId in v.Attacks) {
    //             const attackVT = {
    //                 attackId: attackId,
    //                 targetId: v.TargetId,
    //                 vectorId: v.Id,
    //                 vector: v,
    //                 target: vt.target,
    //                 attackProps: v.Attacks[attackId]
    //             }
    //             attackData[attackId] = attackVT;
    //         }
    //     }
    //     return attackData;
    // }

    // const allAttacksWithVTData = extractAttacksWithVTPairs(allVectorTargetPairs);

  useEffect(() => {
      // console.log("customerId", customerId, "loadingMetaAttacks", loadingMetaAttacks, "metaAttacks", metaAttacks, !loadingMetaAttacks && (!metaAttacks || !metaAttacks[customerId]))
      if (customerId && !loadingMetaAttacks && (!metaAttacks || !metaAttacks[customerId])) {
          dispatch(fetchPerimeterAttacksMetaAction({
              customerId: customerId
          }));
      }

      if (!customers && !loadingCustomers) {
          // console.log("Customers is empty, fetching.")
          dispatch(fetchCustomers());
      } else if (customer && vectors === null && !loadingVectors) {
          // console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
          dispatch(fetchVectorsAction({
              customerId: customer.CustomerId
          }));
      } else if (customer && targets === null && !loadingTargets) {
          dispatch(fetchTargets({
              customerId: customer.CustomerId
          }));
      } else if (customer && requestedAttacksForCustomer === {} && !loadingRequestedAttacks) {
          // console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
          dispatch(fetchRequestedAttacks({
              customerId: customer.CustomerId
          }));
      }

      //TODO: add this back in when start looking at phishing attacks
      // if (!customers && !loadingCustomers) {
      //     // console.log("Customers is empty, fetching.")
      //     // dispatch(fetchCustomers());
      // } else if (customer && campaigns === null && !loadingCampaigns) {
      //     console.log("campaigns is empty, fetching vectors for customerId = ", customer.CustomerId);
      //     dispatch(fetchCampaignsAction({
      //         customerId: customer.CustomerId
      //     }));
      // }
    // console.groupEnd()
  }, [customers, metaAttacks, loadingMetaAttacks, customerId, customerInView, activeTargets, dispatch, loadingCustomers, loadingTargets, loadingVectors, loadingRequestedAttacks, requestedAttacks,
            customer, targets, vectors]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={""}>
        Attack Browser <Tooltip title={"Attacks requested via self-directed Insider Threats. Select a row to view the details in the Attack Inspector."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

  // const userTableHeadings = [
  //     //{ field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
  //     { field: 'id', headerName: 'Attack ID', hide: true, flex : 2, sortable: true, type: 'string', },
  //     { field: 'targetId', headerName: 'Target ID', hide: true, flex : 2, sortable: true, type: 'string', },
  //     { field: 'vectorId', headerName: 'Vector ID', hide: true, flex : 2, sortable: true, type: 'string', },
  //     { field: 'breached', headerName: 'Result', hide: false, sortable: true, type: 'string', width: 75,
  //         renderCell: (params) => (
  //             <Tooltip
  //                 title={params.value ? `Attack achieved breach` : "This attack was blocked by your defenses; it did not cause a breach."}
  //             >
  //                 <span>
  //                     {params.value
  //                         ? <ExitToAppSharpIcon className={"text-danger"}/>
  //                         : <BBIconShieldBounce className={"text-success"}/>}
  //                 </span>
  //             </Tooltip>
  //         ),
  //     },
  //     { field: 'attackDateTime', headerName: 'Attack Date', sortable: true, type: 'dateTime', renderCell: (params) => (<Tooltip title={bbFormattedDateString(params.value, "long")}><span>{bbFormattedDateString(params.value, "short")}</span></Tooltip>), flex : 1, },
  //     { field: 'attackCapabilityName', headerName: 'Attack Type', hide: false, sortable: true, type: 'string', flex:2,
  //         renderCell: (params) => (
  //             <Tooltip
  //                 title={params.getValue('attackCapabilityDescription')}
  //             >
  //                 <span>
  //                     {params.value}
  //                 </span>
  //             </Tooltip>
  //         ),
  //     },
  //
  //     { field: 'attackTacticName', headerName: 'Goal', hide: false, sortable: true, type: 'string', flex:1,
  //         renderCell: (params) => (
  //             <Tooltip
  //                 title={`${params.getValue('attackTacticCategory')} - Select to learn more about this ATT&CK tactic at mitre.org.`}
  //             >
  //                 <a rel="noreferrer" target="_blank" href={params.getValue('attackTacticUrl')}>
  //                     {params.value}
  //                 </a>
  //             </Tooltip>
  //         ),
  //     },
  //     { field: 'statusId', headerName: 'Status ID', hide: true, flex : 0.5, sortable: true, type: 'string', },
  //     { field: 'statusName', headerName: 'Status', hide: true, flex : 1, sortable: true, type: 'string', },
  //     { field: 'statusDescription', headerName: 'Details', hide: true, flex : 2, sortable: true, type: 'string', },
  //
  //     { field: 'attackDateTimeLong', headerName: 'UTC Datetime', hide: true, flex : 2, sortable: true, type: 'string',
  //         valueGetter: (params) =>
  //             bbFormattedDateString(params.getValue('attackDateTime'), "UTC")},
  //
  //
  //
  //
  //     { field: 'isTargetActive', headerName: 'Active', hide: true, sortable: true, type: 'string', width: 80,
  //         renderCell: (params) => (
  //             <Tooltip
  //                 title={params.value ? `Target is currently active.` : "Target is not active and may have moved or become obfuscated."}
  //             >
  //                 <span>
  //                     {params.value
  //                         ? <BBIconCircleFull className={"text-success"}/>
  //                         : <BBIconCircleEmpty className={"text-gray"}/>}
  //                 </span>
  //             </Tooltip>
  //         ),
  //     },
  //     // { field: 'ipAddress', headerName: 'IP', hide: false, sortable: true, type: 'string', flex : 1, renderCell: (params) => (<code>{params.value}</code>)},
  //     { field: 'targetDomain', headerName: 'Target Domain', hide: true, sortable: true, type: 'string', flex : 2,renderCell: (params) => {
  //         if (params.getValue("domainTooltip")) {
  //             // return <Tooltip title={`Fully Qualified Domain Names: ${params.value}`}>
  //             //             <code>
  //             //                 {params.value}
  //             //             </code>
  //             // </Tooltip>
  //             return <>
  //                 <small><code>
  //                     {params.value}
  //                 </code></small></>
  //         } else {
  //             return params.value
  //         }
  //
  //         }},
  //     { field: 'targetUri', headerName: 'Target', hide: false, sortable: true, type: 'string', flex : 2.5,renderCell: (params) => {
  //             if (params.getValue("domainTooltip")) {
  //                 // return <Tooltip title={`Fully Qualified Domain Names: ${params.value}`}>
  //                 //             <code>
  //                 //                 {params.value}
  //                 //             </code>
  //                 // </Tooltip>
  //                 return <><Tooltip
  //                     title={params.getValue("isTargetActive") ? `Target is currently active.` : "Target is not active and may have moved or become obfuscated."}
  //                 >
  //                 <span className={"mr-1"}>
  //                     {params.getValue("isTargetActive")
  //                         ? <BBIconCircleFull className={"text-success"}/>
  //                         : <BBIconCircleEmpty className={"text-gray"}/>}
  //                 </span>
  //                 </Tooltip>
  //                     <small><code>
  //                         {params.value}
  //                     </code></small></>
  //             } else {
  //                 return params.value
  //             }
  //
  //         }},
  //     { field: 'originIp', headerName: 'Origin', hide: true, flex : 1, sortable: true, type: 'string', renderCell: (params) => (<code>{params.value}</code>)},
  //
  //     // { field: 'os', headerName: 'OS', sortable: true, type: 'string', width: 75, renderCell: (params) => (
  //     //         <Tooltip title={`Target Operating System: ${params.value} | ${params.getValue('osDetailsDescription')}`}>
  //     //               <span>
  //     //                   {(params.getValue('osDetails') && params.getValue('osDetailsLogo')) && <img style={{height: 18}} src={params.getValue('osDetailsLogo')} alt={`${bbShortenString(params.value, 25, true)}`} />}
  //     //                   {(!params.getValue('osDetails') || !params.getValue('osDetailsLogo')) && params.value}
  //     //               </span>
  //     //         </Tooltip>
  //     //     )},
  //     // { field: 'services', headerName: 'Services', sortable: true, type: 'string', flex : 2},
  //     // { field: 'ports', headerName: 'Ports', sortable: true, type: 'string', flex : 2},
  //     // { field: 'vulnerabilities', headerName: 'Vulns', hide: true, sortable: true, type: 'string', flex : .75, renderCell: (params) => (params.value)},
  //
  // ];

    const userTableHeadings = [
        //{ field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
        { field: 'id', headerName: 'Attack ID', hide: true, flex : 1, sortable: true, type: 'string', },
        { field: 'statusName', headerName: 'Status', hide: false, width:150, sortable: true, type: 'string', renderCell: (params) => {

            const names = bbGetRequestedAttackStatusNameFromID(params.row.statusId);

                return <Tooltip
                    title={`${params.value} | ${params.row.statusDescription} | ${params.row.statusId}`}>
                    <div>
                        <Chip
                            label={names.label}
                            avatar={names.avatar}
                            color={params.row.statusId === 1 ? "primary" : "default"}
                            className={params.row.statusId === 1 || params.row.wasRowJustAdded ? "btn-floating pulse pulse-single" : ""}

                        />
                    </div>

                </Tooltip>
            },
            // cellClassName: (params: GridCellClassParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",
        },
        { field: 'statusDescription', headerName: 'Status Details', hide: true, flex : 2, sortable: true, type: 'string',renderCell: renderCellExpand },
        { field: 'attackRequestedDateTime', headerName: 'Requested Date', sortable: true, type: 'dateTime', renderCell: (params) => (<Tooltip title={bbFormattedDateString(params.value, "long")}><span>{bbFormattedDateString(params.value, "short")}</span></Tooltip>), flex : 1, },

        { field: 'attackTypeName', headerName: 'Type', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) => (
                <Tooltip title={`${params.value} | ${params.row.attackTypeDescription}`}>
                    <span>
                        {params.value}
                    </span>
                </Tooltip>
            )},
        // { field: 'statusId', headerName: 'Status ID', hide: true, flex : 0.5, sortable: true, type: 'string', },
        // { field: 'statusName', headerName: 'Status', hide: true, flex : 1, sortable: true, type: 'string', },


        { field: 'toolkitName', headerName: 'Toolkit', hide: false, flex : 0.65, sortable: true, type: 'string', renderCell: (params) => (
                <Tooltip title={`${params.value} | ${params.row.toolkitDescription}`}>
                    <span>
                        {params.value}
                    </span>
                </Tooltip>
            )},
        { field: 'toolkitDescription', headerName: 'Toolkit Details', renderHeader: () => "Details" ,hide: false, flex : 2, sortable: true, type: 'string', renderCell: renderCellExpand},

        { field: 'attackDateTimeLong', headerName: 'UTC Datetime', hide: true, flex : 1, sortable: true, type: 'string',
            valueGetter: (params) =>
                bbFormattedDateString(params.row.attackRequestedDateTime, "UTC"), renderCell: renderCellExpand},


        { field: 'originIp', headerName: 'Origin', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) => (<code>{params.value}</code>)},
        { field: 'isAttackComplete', headerName: 'Attack Complete', renderHeader: () => "Complete?", hide: true, flex : 1, sortable: true, type: 'string', },

    ];


    const tableData = requestedAttacksForCustomer ? mapObject(requestedAttacksForCustomer, (key, attack) => {
        return (
            {
                customerId: customer.CustomerId,
                id: key,
                // attacks
                attackRequestedDateTime: attack["Requested DateTime"],
                breached: attack.Status.Id === 5,
                statusId: attack.Status.Id,
                // statusName: attack.Status.Name,
                statusName: bbGetRequestedAttackStatusNameFromID(attack.Status.Id).label,
                statusDescription: attack.Status.Description,
                originIp: attack["Attack Origination Ip"],

                attackTypeId: attack["Attack Type"].Id,
                attackTypeName: attack["Attack Type"].Name,
                attackTypeDescription: attack["Attack Type"].Description,

                toolkitId: attack.Toolkit.Id,
                toolkitName: attack.Toolkit.Name,
                toolkitDescription: attack.Toolkit["Description Long"],

                attackPackageName: attack["Attack Package Details"].Name,
                attackPackageDescription: attack["Attack Package Details"].Description,

                isAttackComplete: attack["Attack Complete"],

            }
        )
    }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    const calcProgressValue = () => {
        // console.log("tableData", tableData, "totalNumAttacks", totalNumAttacks, "metaAttacks", metaAttacks)
        if (totalNumAttacks === 0){
            return 100;
        } else if (!totalNumAttacks || !tableData) {
            return 0;
        } else {
                return Object.keys(tableData).length / totalNumAttacks * 100;
            }

        // return !loadingVectors ? 100 : 0;
    }

    const calcBufferValue = () => {
        if (totalNumAttacks === 0){
            return 100;
        } else if (!totalNumAttacks || !tableData) {
            return 50;
        } else {
            return (Object.keys(tableData).length + 10) / totalNumAttacks * 100;
        }
    }

    const calcLoadingState = () => {
        if (totalNumAttacks === 0){
            return false;
        } else if (Object.keys(tableData).length === 0) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <div >
            <BBDataTable
                columns={userTableHeadings}
                rows={tableData ? tableDataAsArray() : []}
                totalRows={totalNumAttacks ? totalNumAttacks : 0}
                progressValue={calcProgressValue()}
                bufferValue={calcBufferValue()}
                title={title}
                loading={calcLoadingState()}
                onRowSelected={onRowSelected}
                rowsPerPageOptions = {[5, 10, 25, 50, 100]}
                defaultPageSize= {5}
                defaultSortModel = {[
                    {
                        field: 'attackRequestedDateTime',
                        sort: 'desc',
                    }

                ]}
                />
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
    onRowSelected: PropTypes.func
};

export default TableContainer